var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 25,
    viewBox: "0 0 36 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3435 12.5899L35.2156 20.281V4.57397L23.3435 12.5899Z",
    fill: "#7CB93C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.57397V20.281L11.8721 12.5899L0 4.57397Z",
    fill: "#7CB93C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0146 0H2.20097C1.10268 0 0.231098 0.839021 0.0660248 1.91939L17.6078 13.7628L35.1496 1.91939C34.9845 0.839021 34.1129 0 33.0146 0Z",
    fill: "#7CB93C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3275 13.9522L18.2131 16.0543C18.0282 16.1783 17.8191 16.2392 17.6078 16.2392C17.3965 16.2392 17.1874 16.1783 17.0025 16.0543L13.8881 13.95L0.0704193 22.9064C0.239894 23.9777 1.10708 24.81 2.20096 24.81H33.0146C34.1085 24.81 34.9757 23.9777 35.1452 22.9064L21.3275 13.9522Z",
    fill: "#7CB93C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f978c2defdbefae90c828d948613d5ee.svg";
export { ForwardRef as ReactComponent };